import axios from "axios";
import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import BaseUrl from "../../BaseUrl";
import { ApiResponseContext } from "./ApiResponseContext";

const Detailedsearch = () => {
  const [title, setTitle] = useState("");
  const [profession, setProfession] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [, setResult] = useState([]);
  const context = useContext(ApiResponseContext);
  const history = useHistory();

  const Search = () => {
    const Data = new FormData();
    Data.append("jobtitle", title);
    Data.append("zipcode", zipcode);
    Data.append("profession", profession);
    var config = {
      method: "post",
      url: `${BaseUrl.baseurl}/profession/search`,
      data: Data,
    };

    axios(config)
      .then(function (response) {
        console.log(response?.data);
        setResult(response?.data?.professions);
        context.setData(response.data.professions);
        history.push("/browse-job-filter-list");
      })
      .catch(function (error) {
        console.log(error);
        Swal.fire({
          showCloseButton: true,
          toast: true,
          icon: "error",
          title: error?.response?.data?.message,
          animation: true,
          position: "top-right",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });
      });
  };
  return (
    <>
      <div className="row">
        <div className="col-lg-12 col-md-12 mt-5">
          <form className="dezPlaceAni" onSubmit={(e) => e.preventDefault()}>
            <div className="row">
              <div className="col-lg-4 col-md-4">
                <div className="form-group">
                  <label>KeyWord , JobTitle</label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control search-slt"
                      name=""
                      placeholder=""
                      onChange={(e) => setTitle(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="form-group">
                  <div className="input-group">
                    <select
                      type="text"
                      className="form-control search-slt"
                      name=""
                      placeholder="Professional"
                      onChange={(e) => setProfession(e.target.value)}
                    >
                      <option selected disabled>
                        Select Your Professional
                      </option>
                      <option>Attorney</option>
                      <option>Accountant</option>
                      <option>Advisor</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="form-group">
                  <div className="input-group">
                    <input
                      type="number"
                      className="form-control search-slt"
                      name=""
                      placeholder="ZipCode"
                      onChange={(e) => setZipcode(e.target.value)}
                    />
                    <div className="input-group-append">
                      <span className="input-group-text ">
                        <button
                          className="btn btn-outline-primary rounded"
                          onClick={Search}
                        >
                          <i className="fa fa-search "></i>
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Detailedsearch;
